import React from "react";
import { Link } from "react-router-dom";
import Card from "../../../components/ui-components/Card";
import { scopeToSearchParams } from "../../cost-analyzer/useAnalyzerScope";

// Usage answers "what is driving that cost", against the same AI usage data the
// global monitor shows, narrowed to this one initiative.
//
// data-testid="usage-tab" on the root is the stable marker
// UseCaseDetailPage's tab-switching tests assert on to prove this tab body
// rendered; kept from the Task 10 placeholder so those tests need no change.
export default function UsageTab({ useCase }) {
  const row = useCase?.row ?? {};
  const params = scopeToSearchParams({
    dim: "use_case",
    ownerFilters: [
      { dimensionCode: "use_case", nodes: [{ id: row.nodeId, label: row.name }] },
    ],
  });
  // See FinancialsTab.jsx: the second encoding pass here is deliberate, not
  // redundant — it matches the analyzer's own read-back contract (one decode
  // on read from URLSearchParams.get, a second via searchParamsToScope).
  const monitorHref = `/ai-monitor?${new URLSearchParams(params).toString()}`;

  return (
    <div data-testid="usage-tab">
      <Card>
        <div className="p-4 flex flex-col gap-2">
          <div className="text-text-2 text-xs uppercase">AI usage</div>
          <p className="text-text-2 max-w-prose">
            Requests, tokens, models and providers behind this use case&apos;s spend.
          </p>
          <Link to={monitorHref} className="underline">
            Open in AI Usage
          </Link>
        </div>
      </Card>
    </div>
  );
}
